import { combineReducers } from 'redux'
import loader from './loader';
import userdata from './userdata';
import { i18nReducer } from "react-redux-i18n";
export default combineReducers({
  loader, userdata, i18n: i18nReducer,
})
